/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import type {
  AppDesktopSessionResponse,
  DesktopSessionState,
  DesktopWindowStateResponse,
} from '@poweralpha/common';
import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '../api';
import type { DesktopWindowStateApi } from './app-state/DesktopAppStateStore';

export const getDesktopSessionQueryKey = () => ['desktop-session'];

export const useDesktopSessionQuery = () =>
  useQuery<AppDesktopSessionResponse>({
    queryKey: getDesktopSessionQueryKey(),
    queryFn: () => api.get('desktop/session').json<AppDesktopSessionResponse>(),
    retry: false,
  });

export const useSaveDesktopSessionMutation = () =>
  useMutation<
    AppDesktopSessionResponse,
    Error,
    {
      desktop_state: DesktopSessionState;
      last_agent_conversation_id?: string | null;
    }
  >({
    mutationFn: (payload) =>
      api
        .post('desktop/session', {
          json: payload,
        })
        .json<AppDesktopSessionResponse>(),
  });

/** Server storage for per-view window state, see `DesktopAppStateStore`. */
export const desktopWindowStateApi: DesktopWindowStateApi = {
  load: async (windowId) =>
    (
      await api
        .get(`desktop/windows/${encodeURIComponent(windowId)}/state`)
        .json<DesktopWindowStateResponse>()
    ).views,
  save: async (windowId, patch) => {
    await api.post(`desktop/windows/${encodeURIComponent(windowId)}/state`, { json: patch });
  },
  removeWindow: async (windowId) => {
    await api.post(`desktop/windows/${encodeURIComponent(windowId)}/state/delete`);
  },
};
